export const ProductTotalNumber = 1;

export const featureName = 'product';
export interface IProductListResponse {
  totalElements: number;
  totalPages: number;
  pageable: {
    sort: {
      sorted: boolean;
      empty: boolean;
      unsorted: boolean;
    };
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  content: IProduct[];
}

export interface IProduct {
  id: string;
  categoryId: string;
  productName: string;
  productCode: string;
  description: string;
  urlImage: string;
  activeTax: boolean;
  sellPrice: number;
  originalPrice: number;
  quantity: number;
  inventory: number;
  quantitySold: number;
  discount: number;
  createdDate: string;
}

export interface ICategory {
  id: string;
  storeId: string;
  categoryName: string;
  orderNumber: number;
  numberProducts: number;
}

export type GetProductListAction = {
  categoryId?: string;
  page?: number;
  size?: number;
  search?: string;
};

export type CreateProductBody = {
  productName: string;
  categoryId: string;
  productCode: string;
  supplierId: string;
  description: string;
  sellPrice: number;
  originalPrice: number;
  inventory: number;
  base64?: string;
  activeTax: boolean;
  subCode?: string;
  promotion?: {
    id?: string;
    title: string;
    discountType: string;
    discountValue: number;
    startDate: string;
    endDate: string;
    type: string;
    requiredMember?: boolean;
  };
};

export type UpdateProductBody = {
  productId: string;
  productName: string;
  categoryId: string;
  productCode: string;
  supplierId: string;
  description: string;
  sellPrice: number;
  originalPrice: number;
  inventory: number;
  base64?: string;
  activeTax: boolean;
  quantity?: number;
  subCode?: string;
  promotion?: {
    id?: string;
    title: string;
    discountType: string;
    discountValue: number;
    startDate: string;
    endDate: string;
    type: string;
    requiredMember?: boolean;
  };
};

export type UpdateProductTaxBody = {
  productId: string;
  enable: boolean;
};

export interface IResProductDetailsType {
  id: string;
  categoryId: string;
  productName: string;
  supplierId: string;
  productCode: string;
  subCode: string;
  description: string;
  urlImage: string | null;
  activeTax: boolean;
  sellPrice: number;
  originalPrice: number;
  quantity: number;
  inventory: number;
  quantitySold: number;
  discount: number | null;
  createdDate: string;
  promotion: {
    id: string;
    title: string;
    discountType: 'PERCENT' | 'MONEY';
    discountValue: number;
    startDate: string;
    endDate: string;
    type: 'ALL_PRODUCT' | 'BY_PRODUCT';
    requiredMember?: boolean;
  } | null;
}

export type ICreateOrUpdateSupplierBody = {
  id?: string;
  name: string;
  phone: string;
  email: string;
  description?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  website?: string;
};

export type IResSupplierItemContent = {
  id: string;
  name: string;
  code: string | null;
  email: string;
  phone: string;
  active: boolean;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  description: string | null;
  website: string | null;
  lastOrderDate: string | null;
  totalProducts: number;
  quantity: number;
  totalSold: number;
  inventory: number;
  totalPrice: number;
};

export const PRODUCT_PAGE_SIZE = 20;
